//
// locale_co.js
// automatically generated by generateLocalePacks.js
//
import messages from '../../app/javascript/gabsocial/locales/co.json';
import localeData from "../../app/javascript/gabsocial/locales/locale-data/co.js";
import { setLocale } from '../../app/javascript/gabsocial/locales';
setLocale({messages, localeData});
